import { render, staticRenderFns } from "./jumpmp.vue?vue&type=template&id=95905d3c&scoped=true&"
import script from "./jumpmp.vue?vue&type=script&lang=js&"
export * from "./jumpmp.vue?vue&type=script&lang=js&"
import style0 from "./jumpmp.vue?vue&type=style&index=0&id=95905d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95905d3c",
  null
  
)

export default component.exports